/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-09-27 02:24:13
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import React, { Component } from 'react';
import { TextStyle, Badge, Link } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { AppType } from 'src/constants/integration';
import { connect } from 'react-redux';

type Props = {
  list: Array,
  emailSupport: string
};

type ComposedProps = Props & WithI18nProps;

class DefaultCard extends Component<ComposedProps> {
  render() {
    const { i18n, list, emailSupport } = this.props;
    return (
      <div>
        {list.map((row, rowIndex) => {
          return (
            <div style={{ display: 'flow-root' }} key={`row-` + rowIndex}>
              {row.map((item, index) => {
                const {
                  name,
                  integration,
                  icon,
                  description,
                  appListingURL,
                  instructionURL,
                  iconStyle,
                  render,
                  isManually,
                  appType,
                  themeSetupV3
                } = item;

                const isShowBadge = themeSetupV3 || [AppType.reviews, AppType.labels].includes(appType);
                const isUseRender =
                  themeSetupV3 ||
                  [AppType.reviews, AppType.currencies, AppType.others, AppType.labels, AppType.smsEmail].includes(
                    appType
                  );

                return render && isUseRender ? (
                  <div key={`item-` + index}>{render(index, item)}</div>
                ) : (
                  <div className={index === 1 ? 'item middle' : 'item'} key={`item-` + index}>
                    <a
                      className="Polaris-Link"
                      href={appListingURL}
                      target="_blank"
                      rel="noopener noreferrer">
                      <img
                        className="icon"
                        src={icon}
                        alt={i18n.translate(name)}
                        style={iconStyle ? iconStyle : {}}
                      />
                    </a>
                    {/* Integration type */}
                    {integration && isShowBadge && (
                      <div className="integration">
                        <Badge status={isManually ? '' : 'info'}>
                          {i18n.translate(integration)}
                        </Badge>
                      </div>
                    )}
                    {/* App name*/}
                    <div className="name">{i18n.translate(name)}</div>
                    {/* App description*/}
                    <div className="description">{i18n.translate(description)}</div>
                    {/* App instruction*/}
                    {_.isEmpty(instructionURL) ? (
                      <div className="instruction">
                        {i18n.translate('AdminHTML.Integration.Integration.instructionContact', {
                          nt_email: <TextStyle variation="strong">{emailSupport}</TextStyle>
                        })}
                      </div>
                    ) : (
                      <div className="instruction">
                        {i18n.translate('AdminHTML.Integration.Integration.instruction', {
                          t: (
                            <Link external url={instructionURL}>
                              {i18n.translate('AdminHTML.Integration.Integration.instruction_t', {
                                nt_name: i18n.translate(name)
                              })}
                            </Link>
                          )
                        })}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  // Show/hide by themeSetupV2
  const themeSetupV2 = _.get(state.oauth, 'tenantApp.adminAppFeatures.themeSetupV2', false);
  const themeSetupV3 = _.get(state.oauth, 'tenantApp.settings.themeSetupV3.settings.enable', false);

  return {
    themeSetupV3,
    themeSetupV2
  };
};

export default connect(mapStateToProps)(withI18n()(DefaultCard));
